import { FEATURE_FLAG__BEGIN_15 } from "../../../../constants/featureflags";
import {
  CTA_LABEL_FOR_DIFFERENT_TRIAL_LENGTHS,
  EXPERIMENT__DIFFERENT_PLAN_TRIALS,
} from '../../../../experiments/constants';
import { generateVariantData } from "../../../../experiments/utils";

export const getBannerData = (planLabels, key) => {
  const { trialLabel, startFreeTrialLabel } = planLabels;
  const defaultBanner = {
    bgColor: '#DECDFE',
    textColor: '#21375B',
    bannerTextDesktop: "Kids don't just play games, they can build them!",
    bannerCtaText: trialLabel,
    bannerTextMobile: startFreeTrialLabel,
  }
  const bannerData = {
    base: defaultBanner,
    [EXPERIMENT__DIFFERENT_PLAN_TRIALS]: {
      ...defaultBanner,
      bannerCtaText: CTA_LABEL_FOR_DIFFERENT_TRIAL_LENGTHS,
      bannerTextMobile: CTA_LABEL_FOR_DIFFERENT_TRIAL_LENGTHS,
    },
    [FEATURE_FLAG__BEGIN_15]: {
      bgColor: '#AEF0FF',
      textColor: '#0B3064',
      bannerTextDesktop:
          'For all purchases made by 9/1, Begin will donate learning products to underserved families 💛',
      bannerCtaText: 'START YOUR FREE TRIAL',
      bannerTextMobile: startFreeTrialLabel,
    },
  };

  return generateVariantData(bannerData)(key);
};



// WEBPACK FOOTER //
// ./src/components/global/Header/bannerData/index.js